import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import SettlementReport from '../Merchants/SettlementReport';
import { fetchSettlementReports } from '../../redux/actions/Data';

const PuppeteerViewSettlementReport = () => {
  const dispatch = useDispatch();
  const {
    data: settlementReports,
  } = useSelector(({ data }) => data.settlementReports);

  const urlParams = new URLSearchParams(window.location.search);
  useEffect(() => {
    if (urlParams.has('id')) {
      const filter = JSON.stringify({
        _id: urlParams.get('id'),
      });
      const pagination = `filter=${filter}`;
      dispatch(fetchSettlementReports(pagination));
    }
  }, [dispatch]);

  if (settlementReports?.length === 0) {
    return <div id="loading">View Report</div>;
  }

  let parent = 0;
  if (urlParams.has('parent')) {
    parent = Number(urlParams.get('parent'));
  }
  const record = settlementReports[0];
  return (
    <SettlementReport {...{
      wallet: {
        code: record.wallet_currency_code,
      },
      selectedMerchant: {
        name: record.merchant_name,
        merchant_id: record.merchant_code,
        _id: record.merchant_id,
        enable_affiliate: record.is_affiliate,
        card_settlement_period: record.card_settlement_period,
      },
      handleChange: () => { },
      isAffiliate: record?.is_affiliate,
      editable: record,
      puppeteerPDF: true,
      puppeteerParent1PDF: parent === 1,
      puppeteerParent2PDF: parent === 2,
    }}
    />
  );
};

export default PuppeteerViewSettlementReport;
